import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { UnitQuantity, UnitQuantityControl } from 'src/app/form-controls/unit-quantity/unit-quantity.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { WeightAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';
import { ActionAlertComponent } from '../../action-alert/action-alert.component';

interface WeightActionFormGroup {
	weight: FormControl<UnitQuantity | null>;
}

@Component({
    selector: 'app-weight-action-controls',
    templateUrl: './weight-action-controls.component.html',
    styleUrls: ['../../../common.scss', './weight-action-controls.component.scss'],
    imports: [CommonActionControlsComponent, ActionFormComponent, ReactiveFormsModule, UnitQuantityControl, ActionAlertComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WeightActionControlsComponent implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: WeightAction;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as WeightAction;
	}

	@Input() form!: FormGroup<WeightActionFormGroup>;
	@Input() item!: Row | null;

	constructor(private formBuilder: FormBuilder) {
	}

    ngOnInit(): void {
        this.form.addControl('weight', this.formBuilder.control(this.action?.weight ?? null));
    }
}